import moment from 'moment-timezone';

// Compact label for a filter's date range: "Sep 9 – Oct 9, 2026".
// The year is repeated only when the range crosses one.
export function formatDateRange(startDate, endDate) {
  if (!startDate || !endDate) return 'Any date';
  const start = moment(startDate);
  const end = moment(endDate);
  if (start.isSame(end, 'day')) return start.format('MMM D, YYYY');
  if (start.isSame(end, 'year')) {
    return `${start.format('MMM D')} – ${end.format('MMM D, YYYY')}`;
  }
  return `${start.format('MMM D, YYYY')} – ${end.format('MMM D, YYYY')}`;
}
